import { useState } from "react";
import { createFileRoute, useNavigate, useSearch, Link } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import logo from "@/assets/kk-logo.webp";

export const Route = createFileRoute("/auth")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search["redirect"] === "string" ? (search["redirect"] as string) : undefined,
  }),
  head: () => ({ meta: [{ title: "Acesso restrito | Dr. Kelson Kawamura" }, { name: "robots", content: "noindex" }] }),
  component: AuthPage,
});

function AuthPage() {
  const navigate = useNavigate();
  const { redirect } = useSearch({ from: "/auth" });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (err) {
      setError("E-mail ou senha inválidos.");
      return;
    }
    navigate({ to: redirect && redirect.startsWith("/") ? redirect : "/admin" });
  }

  return (
    <div className="kk-login">
      <div>
        <div className="kk-login__card">
          <img src={logo} alt="Dr. Kelson Kawamura" className="kk-login__logo" />
          <h1>Área administrativa</h1>
          <p className="kk-login__sub">Entre para gerenciar o conteúdo do site.</p>
          <form onSubmit={onSubmit} className="kk-form">
            <label>
              E-mail
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            </label>
            <label>
              Senha
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </label>
            {error ? <p className="kk-form__error">{error}</p> : null}
            <button type="submit" className="kk-button-primary" disabled={loading}>
              {loading ? "Entrando…" : "Entrar"}
            </button>
          </form>
        </div>
        <Link to="/" className="kk-login__back">
          ← Voltar para o site
        </Link>
      </div>
    </div>
  );
}
